/* Il nome italiano di un luogo, **solo per la resa**.

   A monte i titoli delle voci `wiki` di tipo Country/City/Location sono
   in italiano sui dispacci recenti, ma su quelli più vecchi (fino al 2025
   circa) arrivano spesso in inglese: sullo stesso dispaccio 165 si legge
   «Saudi Arabia», «Central Asia», «Great Britain» accanto a «Pechino».
   Campionati il 01/10/2026 seicento dispacci fino a giugno 2025 e
   quattrocento recenti (/tmp/pwmeas/notizia/luoghi*.jsonl): la tabella
   qui sotto copre i nomi inglesi trovati, più le varianti ovvie.

   Cambia l'etichetta e basta. Il nome originale resta quello con cui si
   filtra (`/ricerca?place=…` cerca il titolo esatto a monte) e quello
   che la mappa risolve (`risolviLuoghi` in lib/mappaLuoghi.ts, che qui
   non si tocca): tradurlo nei collegamenti romperebbe i filtri.

   Modulo senza direttiva: lo leggono server e client. */

const NOMI_IT: Record<string, string> = {
  // Paesi
  Afganistan: "Afghanistan",
  Azerbaijan: "Azerbaigian",
  Belarus: "Bielorussia",
  "Bosnia and Herzegovina": "Bosnia ed Erzegovina",
  China: "Cina",
  Croatia: "Croazia",
  Cyprus: "Cipro",
  "Democratic Republic of the Congo": "Repubblica Democratica del Congo",
  Djibouti: "Gibuti",
  Egypt: "Egitto",
  Ethiopia: "Etiopia",
  France: "Francia",
  "French Republic": "Francia",
  Germany: "Germania",
  "Great Britain": "Regno Unito",
  "United Kingdom": "Regno Unito",
  Greece: "Grecia",
  Hungary: "Ungheria",
  Israel: "Israele",
  Italy: "Italia",
  Japan: "Giappone",
  Jordan: "Giordania",
  Kazakhstan: "Kazakistan",
  Kyrgyzstan: "Kirghizistan",
  Lebanon: "Libano",
  Libya: "Libia",
  Netherlands: "Paesi Bassi",
  "Northern Cyprus": "Cipro del Nord",
  "North Korea": "Corea del Nord",
  Norway: "Norvegia",
  Palestine: "Palestina",
  "Republic of Singapore": "Repubblica di Singapore",
  "Republic of Srpska": "Republika Srpska",
  "Republic of the Congo": "Repubblica del Congo",
  "Saudi Arabia": "Arabia Saudita",
  "South Africa": "Sudafrica",
  "South Korea": "Corea del Sud",
  Spain: "Spagna",
  Switzerland: "Svizzera",
  Syria: "Siria",
  Thailand: "Thailandia",
  Turkey: "Turchia",
  Türkiye: "Turchia",
  Ukraine: "Ucraina",
  "United Arab Emirates": "Emirati Arabi Uniti",
  "United States of America": "Stati Uniti d'America",
  "United States": "Stati Uniti",
  USA: "Stati Uniti",
  "Western Sahara": "Sahara Occidentale",
  // Aree e regioni
  "Central Asia": "Asia centrale",
  Europe: "Europa",
  "Middle East": "Medio Oriente",
  "Gaza Strip": "Striscia di Gaza",
  "West Bank": "Cisgiordania",
  "Kuril Islands": "Isole Curili",
  Balochistan: "Belucistan",
  "Sistan and Baluchestan province": "Sistan e Belucistan",
  // Mari, stretti, porti
  "Gulf of Aden": "Golfo di Aden",
  "Oman Gulf": "Golfo di Oman",
  "Red Sea": "Mar Rosso",
  "Strait of Hormuz": "Stretto di Hormuz",
  "Suez Canal": "Canale di Suez",
  "Bab al-Mandab": "Bab el-Mandeb",
  "Chabahar Port": "Porto di Chabahar",
  // Città
  Baghdad: "Bagdad",
  Beijing: "Pechino",
  Damascus: "Damasco",
  Kyiv: "Kiev",
  "New Delhi": "Nuova Delhi",
  Riyadh: "Riad",
  Moscow: "Mosca",
  Athens: "Atene",
  Jerusalem: "Gerusalemme",
};

/** Il nome da mostrare per un luogo: la traduzione se il nome a monte è
 *  inglese e noto, altrimenti il nome com'è. */
export function etichettaLuogo(nome: string): string {
  const n = nome.trim();
  return NOMI_IT[n] ?? n;
}
